import { render, staticRenderFns } from "./form-input.vue?vue&type=template&id=2c9d1c4d&scoped=true&"
import script from "./form-input.vue?vue&type=script&lang=js&"
export * from "./form-input.vue?vue&type=script&lang=js&"
import style0 from "./form-input.vue?vue&type=style&index=0&id=2c9d1c4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9d1c4d",
  null
  
)

export default component.exports